var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "toolbar-panel" },
    [
      _c(
        "v-item-group",
        { staticClass: "v-btn-toggle", attrs: { light: _vm.isFullscreen } },
        [
          !_vm.structureFileButtonDisabled
            ? _c(
                "v-btn",
                _vm._b(
                  {
                    attrs: { title: _vm.structureFileButtonLabel },
                    on: {
                      click: function ($event) {
                        _vm.$emit("makeCIF")
                        _vm.$emit("makePDB")
                      },
                    },
                  },
                  "v-btn",
                  _vm.toolbarButtonProps,
                  false
                ),
                [
                  _c(
                    "v-icon",
                    _vm._b({}, "v-icon", _vm.toolbarIconProps, false),
                    [_vm._v(_vm._s(_vm.structureFileIcon))]
                  ),
                  _vm._v(" "),
                  _vm.isFullscreen
                    ? _c("span", [
                        _vm._v(" " + _vm._s(_vm.structureFileButtonLabel)),
                      ])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.disableImageButton
            ? _c(
                "v-btn",
                _vm._b(
                  {
                    attrs: { title: "Save image" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("makeImage")
                      },
                    },
                  },
                  "v-btn",
                  _vm.toolbarButtonProps,
                  false
                ),
                [
                  _c(
                    "v-icon",
                    _vm._b({}, "v-icon", _vm.toolbarIconProps, false),
                    [_vm._v(_vm._s(_vm.$MDI.SavePNG))]
                  ),
                  _vm._v(" "),
                  _vm.isFullscreen
                    ? _c("span", [_vm._v(" Save image")])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.disableQueryButton
            ? _c(
                "v-btn",
                _vm._b(
                  {
                    attrs: { title: _vm.queryToggleTitle },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("toggleQuery")
                      },
                    },
                  },
                  "v-btn",
                  _vm.toolbarButtonProps,
                  false
                ),
                [
                  _vm.queryColorList.length >= 2
                    ? _c(
                        "span",
                        { staticClass: "two-tone-icon" },
                        [
                          _c(
                            "v-icon",
                            _vm._b(
                              { style: _vm.queryFirstHalfStyle },
                              "v-icon",
                              _vm.toolbarIconProps,
                              false
                            ),
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.queryIconName) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            _vm._b(
                              { style: _vm.querySecondHalfStyle },
                              "v-icon",
                              _vm.toolbarIconProps,
                              false
                            ),
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.queryIconName) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            _vm._b(
                              { staticStyle: { visibility: "hidden" } },
                              "v-icon",
                              _vm.toolbarIconProps,
                              false
                            ),
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.queryIconName) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _c(
                        "v-icon",
                        _vm._b(
                          { style: { color: _vm.queryColorList[0] } },
                          "v-icon",
                          _vm.toolbarIconProps,
                          false
                        ),
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.queryIconName) +
                              "\n        "
                          ),
                        ]
                      ),
                  _vm._v(" "),
                  _vm.isFullscreen
                    ? _c("span", [_vm._v(" Toggle full query")])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.disableTargetButton
            ? _c(
                "v-btn",
                _vm._b(
                  {
                    attrs: { title: _vm.targetToggleTitle },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("toggleTarget")
                      },
                    },
                  },
                  "v-btn",
                  _vm.toolbarButtonProps,
                  false
                ),
                [
                  _vm.targetColorList.length >= 2
                    ? _c(
                        "span",
                        { staticClass: "two-tone-icon" },
                        [
                          _c(
                            "v-icon",
                            _vm._b(
                              { style: _vm.targetFirstHalfStyle },
                              "v-icon",
                              _vm.toolbarIconProps,
                              false
                            ),
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.targetIconName) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            _vm._b(
                              { style: _vm.targetSecondHalfStyle },
                              "v-icon",
                              _vm.toolbarIconProps,
                              false
                            ),
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.targetIconName) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            _vm._b(
                              { staticStyle: { visibility: "hidden" } },
                              "v-icon",
                              _vm.toolbarIconProps,
                              false
                            ),
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.targetIconName) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _c(
                        "v-icon",
                        _vm._b(
                          { style: { color: _vm.targetColorList[0] } },
                          "v-icon",
                          _vm.toolbarIconProps,
                          false
                        ),
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.targetIconName) +
                              "\n        "
                          ),
                        ]
                      ),
                  _vm._v(" "),
                  _vm.isFullscreen
                    ? _c("span", [_vm._v(" Toggle full target")])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.separationToggle
            ? _c(
                "v-btn",
                _vm._b(
                  {
                    attrs: {
                      title: _vm.separateStructures
                        ? "Overlay query and target structures"
                        : "Separate query and target structures while preserving their superposition",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("toggle-structure-separation")
                      },
                    },
                  },
                  "v-btn",
                  _vm.toolbarButtonProps,
                  false
                ),
                [
                  _c(
                    "v-icon",
                    _vm._b({}, "v-icon", _vm.toolbarIconProps, false),
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.separateStructures
                              ? _vm.$MDI.Layers
                              : _vm.$MDI.LayersOutline
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isFullscreen
                    ? _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.separateStructures
                                ? "Overlay structures"
                                : "Separate structures"
                            )
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.disableArrowButton
            ? _c(
                "v-btn",
                _vm._b(
                  {
                    attrs: { title: "Draw arrows between aligned residues" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("toggleArrows")
                      },
                    },
                  },
                  "v-btn",
                  _vm.toolbarButtonProps,
                  false
                ),
                [
                  _vm.showArrows
                    ? _c(
                        "v-icon",
                        _vm._b({}, "v-icon", _vm.toolbarIconProps, false),
                        [_vm._v(_vm._s(_vm.$MDI.ArrowRightCircle))]
                      )
                    : _c(
                        "v-icon",
                        _vm._b({}, "v-icon", _vm.toolbarIconProps, false),
                        [_vm._v(_vm._s(_vm.$MDI.ArrowRightCircleOutline))]
                      ),
                  _vm._v(" "),
                  _vm.isFullscreen
                    ? _c("span", [_vm._v(" Toggle arrows")])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.disableResetButton
            ? _c(
                "v-btn",
                _vm._b(
                  {
                    attrs: {
                      title:
                        "Reset the view to the original position and zoom level",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("resetView")
                      },
                    },
                  },
                  "v-btn",
                  _vm.toolbarButtonProps,
                  false
                ),
                [
                  _c(
                    "v-icon",
                    _vm._b({}, "v-icon", _vm.toolbarIconProps, false),
                    [_vm._v(_vm._s(_vm.$MDI.Restore))]
                  ),
                  _vm._v(" "),
                  _vm.isFullscreen
                    ? _c("span", [_vm._v(" Reset view")])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.disableSpinButton
            ? _c(
                "v-btn",
                _vm._b(
                  {
                    attrs: { title: "Toggle spinning structure" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("toggleSpin")
                      },
                    },
                  },
                  "v-btn",
                  _vm.toolbarButtonProps,
                  false
                ),
                [
                  _c(
                    "v-icon",
                    _vm._b({}, "v-icon", _vm.toolbarIconProps, false),
                    [_vm._v(_vm._s(_vm.$MDI.AxisZRotateCounterclockwise))]
                  ),
                  _vm._v(" "),
                  _vm.isFullscreen
                    ? _c("span", [_vm._v(" Toggle spin")])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.disableFullscreenButton
            ? _c(
                "v-btn",
                _vm._b(
                  {
                    attrs: {
                      title: "Enter fullscreen mode - press ESC to exit",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("toggleFullscreen")
                      },
                    },
                  },
                  "v-btn",
                  _vm.toolbarButtonProps,
                  false
                ),
                [
                  _c(
                    "v-icon",
                    _vm._b({}, "v-icon", _vm.toolbarIconProps, false),
                    [_vm._v(_vm._s(_vm.$MDI.Fullscreen))]
                  ),
                  _vm._v(" "),
                  _vm.isFullscreen
                    ? _c("span", [_vm._v(" Fullscreen")])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }